<div class="ep-container" *transloco="let t">
    <div class="auth-card">
        <!-- Header -->
        <div class="auth-card-header px-8 py-6 text-center">
            <div class="ep-icon">
                <svg class="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg>
            </div>
            <h1 class="ep-title" *ngIf="!dialogRef">{{ t('profile.changeProfile') }}</h1>
            <h1 class="ep-title" *ngIf="dialogRef">{{ t('profile.changeProfileDialog') }}</h1>
        </div>

        <!-- Form -->
        <div class="px-6 py-8 md:px-10">
            <form [formGroup]="form" class="ep-form">
                <!-- First name -->
                <div class="ep-field">
                    <label class="auth-label">{{ t('checkout.firstName') }}</label>
                    <div class="auth-input-wrap">
                        <svg class="auth-input-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                        </svg>
                        <input type="text" formControlName="firstName" class="auth-input" />
                    </div>
                </div>

                <!-- Last name -->
                <div class="ep-field">
                    <label class="auth-label">{{ t('checkout.lastName') }}</label>
                    <div class="auth-input-wrap">
                        <svg class="auth-input-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                        </svg>
                        <input type="text" formControlName="lastName" class="auth-input" />
                    </div>
                </div>

                <!-- Username -->
                <div class="ep-field">
                    <label class="auth-label">{{ t('auth.username') }}</label>
                    <div class="auth-input-wrap">
                        <svg class="auth-input-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                        </svg>
                        <input type="text" formControlName="username" class="auth-input" />
                    </div>
                </div>

                <!-- Profile picture -->
                <div class="ep-field" *ngIf="!dialogRef">
                    <label class="auth-label">{{ t('profile.profilePicture') }}</label>
                    <button type="button" class="ep-upload-btn" (click)="openProfilePictureModal()">
                        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                        </svg>
                        {{ t('common.upload') }}
                    </button>
                </div>

                <!-- Error message -->
                @if (message) {
                    <p class="ep-error">{{ message }}</p>
                }

                <!-- Buttons -->
                <div class="ep-actions">
                    <button class="auth-btn-dark flex-1" type="button" *ngIf="!dialogRef" (click)="cancel()">
                        {{ t('common.cancel') }}
                    </button>
                    <button class="auth-btn-primary flex-1" type="button" (click)="save()">
                        {{ t('common.save') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
